<template>
	<div class="app-container">
		<el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px">
			<el-form-item label="名称" prop="name">
				<el-input v-model="queryParams.name" placeholder="请输入名称" clearable size="small"
					@keyup.enter.native="handleQuery" />
			</el-form-item>
			<el-form-item label="开始时间" prop="deployTime">
				<el-date-picker clearable size="small" v-model="queryParams.deployTime" type="date"
					value-format="yyyy-MM-dd" placeholder="选择时间">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
				<el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
			</el-form-item>
		</el-form>


		<el-table v-loading="loading" :data="myProcessList" border @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55" align="center" />
			<el-table-column label="流程编号" width="300" align="center" prop="procInsId" />
			<el-table-column label="流程名称" align="center" prop="procDefName" />
			<el-table-column label="流程类别" align="center" prop="category" width="100px" />
			<el-table-column label="流程版本" align="center" width="80px">
				<template slot-scope="scope">
					<el-tag size="medium">v{{ scope.row.procDefVersion }}</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="提交时间" align="center" prop="createTime" width="180" />
			<el-table-column label="流程状态" align="center" width="100">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.finishTime == null" size="mini">进行中</el-tag>
					<el-tag type="success" v-if="scope.row.finishTime != null" size="mini">已完成</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="耗时" align="center" prop="duration" width="180" />
			<el-table-column label="当前节点" align="center" prop="taskName" />
			<el-table-column label="办理" align="center">
				<template slot-scope="scope">
					<label v-if="scope.row.assigneeName">{{scope.row.assigneeName}}
						<el-tag type="info" size="mini">{{scope.row.deptName}}</el-tag>
					</label>
					<label v-if="scope.row.candidate">{{scope.row.candidate}}</label>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="200">
				<template slot-scope="scope">
					<el-button size="mini" type="text" icon="el-icon-tickets" @click="handleFlowRecord(scope.row)">详情
					</el-button>
					<el-button size="mini" type="text" icon="el-icon-tickets" v-if="scope.row.finishTime==null" @click="handleStop(scope.row)">取消申请
					</el-button>
					<el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
			@pagination="getList" />

		<!-- 添加或修改流程定义对话框 -->
		<el-dialog :title="title" :visible.sync="open" width="60%" append-to-body>
			<el-table v-loading="processLoading" fit :data="definitionList" border>
				<el-table-column label="流程编号" width="300" align="center" prop="deploymentId" />
				<el-table-column label="流程名称" align="center" prop="name" />
				<el-table-column label="流程版本" align="center">
					<template slot-scope="scope">
						<el-tag size="medium">v{{ scope.row.version }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="流程分类" align="center" prop="category" />
				<el-table-column label="操作" align="center" width="300" class-name="small-padding fixed-width">
					<template slot-scope="scope">
						<el-button size="mini" type="text" icon="el-icon-edit-outline"
							@click="handleStartProcess(scope.row)">发起流程</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="processTotal>0" :total="processTotal" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getList" />
		</el-dialog>

	</div>
</template>

<script>
	import pagination from "@/components/Pagination/index"
	import {
		getDeployment,
		delDeployment,
		addDeployment,
		updateDeployment,
		exportDeployment,
		flowRecord
	} from "@/api/flowable/finished";
	import {
		myProcessList,
		stopProcess
	} from "@/api/flowable/process";
	import {
		listDefinition
	} from "@/api/flowable/definition";
	export default {
		name: "Deploy",
		components: {
			  pagination
		},
		data() {
			return {
				// 遮罩层
				loading: true,
				processLoading: true,
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,
				// 显示搜索条件
				showSearch: true,
				// 总条数
				total: 0,
				processTotal: 0,
				// 我发起的流程列表数据
				myProcessList: [],
				// 弹出层标题
				title: "",
				// 是否显示弹出层
				open: false,
				src: "",
				definitionList: [],
				// 查询参数
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					name: null,
					category: null,
					key: null,
					tenantId: null,
					deployTime: null,
					derivedFrom: null,
					derivedFromRoot: null,
					parentDeploymentId: null,
					engineVersion: null
				},
				// 表单参数
				form: {},
				// 表单校验
				rules: {},
			};
		},
		created() {
			this.getList();
		},
		methods: {
			/** 查询流程定义列表 */
			getList() {

				this.loading = true;
				this.$http.get("/api/flow/flowable/task/myProcess", {
					params: {
						...this.queryParams
					}
				}).then(response => {
					console.log(response)
					this.myProcessList = response.data.data.records;
					this.processTotal = response.data.data.total;
					this.loading = false;
				});
				// myProcessList(this.queryParams).then(response => {
				//   this.myProcessList = response.data.records;
				//   this.processTotal = response.data.total;
				//   this.loading = false;
				// });
			},
			// 取消按钮
			cancel() {
				this.open = false;
				this.reset();
			},
			// 表单重置
			reset() {
				this.form = {
					id: null,
					name: null,
					category: null,
					key: null,
					tenantId: null,
					deployTime: null,
					derivedFrom: null,
					derivedFromRoot: null,
					parentDeploymentId: null,
					engineVersion: null
				};
				this.resetForm("form");
			},
			/** 搜索按钮操作 */
			handleQuery() {
				this.queryParams.pageNum = 1;
				this.getList();
			},
			/** 重置按钮操作 */
			resetQuery() {
				this.resetForm("queryForm");
				this.handleQuery();
			},
			// 多选框选中数据
			handleSelectionChange(selection) {
				this.ids = selection.map(item => item.id)
				this.single = selection.length !== 1
				this.multiple = !selection.length
			},
			/** 新增按钮操作 */
			handleAdd() {
				this.open = true;
				this.title = "发起流程";
				this.$http.get("/api/flow/flowable/definition/list", {
					params: {
						...this.queryParams
					}
				}).then(response => {
					console.log(response)
					this.definitionList = response.data.data.records;
					this.processTotal = response.data.data.total;
					this.processLoading = false;
				});
				// listDefinition(this.queryParams).then(response => {
				//   this.definitionList = response.data.records;
				//   this.processTotal = response.data.total;
				//   this.processLoading = false;
				// });
			},
			/**  发起流程申请 */
			handleStartProcess(row) {
				this.$router.push({
					path: '/index/task/index',
					query: {
						deployId: row.deploymentId,
						procDefId: row.id,
						finished: true
					}
				})
			},
			/**  取消流程申请 */
			handleStop(row) {
				const params = {
					instanceId: row.procInsId
				}
				this.$http.post("/api/flow/flowable/task/stopProcess", {
					...params
				}).then(res => {
					
					this.$message(res.data.msg);
					this.getList();
				});
				// stopProcess(params).then( res => {
				//   this.msgSuccess(res.msg);
				//   this.getList();
				// });
			},
			/** 流程流转记录 */
			handleFlowRecord(row) {
				this.$router.push({
					path: '/index/task/index',
					query: {
					    procInsId: row.procInsId,
					    deployId: row.deployId,
					    taskId: row.taskId,
					    finished: false
					}
				})
				// this.$router.push({
				// 	path: '/flowable/task/record/index',
				// 	query: {
				// 		procInsId: row.procInsId,
				// 		deployId: row.deployId,
				// 		taskId: row.taskId,
				// 		finished: false
				// 	}
				// })
			},
			/** 修改按钮操作 */
			handleUpdate(row) {
				this.reset();
				const id = row.id || this.ids
				this.$http.get(`/api/system/deployment?id=${id}`).then(response => {
					this.form = response.data;
					this.open = true;
					this.title = "修改流程定义";
				});
				// getDeployment(id).then(response => {
				//   this.form = response.data;
				//   this.open = true;
				//   this.title = "修改流程定义";
				// });
			},
			/** 提交按钮 */
			submitForm() {
				this.$refs["form"].validate(valid => {
					if (valid) {
						if (this.form.id != null) {
							this.$http.put("/api/system/deployment", {
								...this.form
							}).then(response => {
								this.$message("修改成功");
								this.open = false;
								this.getList();
							});
							// updateDeployment(this.form).then(response => {
							//   this.msgSuccess("修改成功");
							//   this.open = false;
							//   this.getList();
							// });
						} else {
							this.$http.post("/api/system/deployment", {
								...this.form
							}).then(response => {
								this.$message("新增成功");
								this.open = false;
								this.getList();
							});
							// addDeployment(this.form).then(response => {
							//   this.msgSuccess("新增成功");
							//   this.open = false;
							//   this.getList();
							// });
						}
					}
				});
			},
			/** 删除按钮操作 */
			handleDelete(row) {
				// const ids = row.id || this.ids;
				const ids=row.procInsId
				this.$confirm('是否确认删除流程定义编号为"' + ids + '"的数据项?', "警告", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(()=> {
					console.log("111")
					this.$http.delete(`/api/flow/flowable/instance/delete?instanceId=${ids}`).then(res => {
						this.getList();
						this.$message.success("删除成功");
					})
					// return delDeployment(ids);
				}).catch(() => {
					this.$message({
						type: 'warning',
						message: '已取消删除'
					});
				});

				// .then(() => {
				//      this.getList();
				//      this.msgSuccess("删除成功");
				//    })
			},
			/** 导出按钮操作 */
			handleExport() {
				const queryParams = this.queryParams;
				this.$confirm('是否确认导出所有流程定义数据项?', "警告", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(function() {
					this.$http.get("/api/system/deployment/export",{
						params:{
							...this.queryParams
						}
					}).then(res=>{
						this.download(response.msg);
					}).catch(err=>{
						
					})
					// return exportDeployment(queryParams);
				})
				// .then(response => {
				// 	this.download(response.msg);
				// })
			}
		}
	};
</script>
